define.alias("shared/components/shared/post/profile-selector/profile-list", "preview-grid/components/shared/post/profile-selector/profile-list/index");